// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__HgoxP","title":"styles_title__7gd83","container":"styles_container__u2K9J"};